<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.academy.menu"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.academy.list.title"></app-i18n>
      </h1>

      <app-academy-list-toolbar></app-academy-list-toolbar>
      <app-academy-list-filter></app-academy-list-filter>
      <app-academy-list-table></app-academy-list-table>
    </div>
  </div>
</template>

<script>
import AcademyListFilter from '@modules/academy/components/academy-list-filter.vue';
import AcademyListTable from '@modules/academy/components/academy-list-table.vue';
import AcademyListToolbar from '@modules/academy/components/academy-list-toolbar.vue';

export default {
  name: 'app-academy-list-page',

  components: {
    [AcademyListFilter.name]: AcademyListFilter,
    [AcademyListTable.name]: AcademyListTable,
    [AcademyListToolbar.name]: AcademyListToolbar,
  },
};
</script>

<style>
</style>
